
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexi8GUXeN_45dbtjNvoGDEzAJY6N1OFPFm5g3zE4hJ4DXoMMeta } from "/opt/build/repo/nuxt/app/pages/index.vue?macro=true";
import { default as _91_46_46_46slug_93umOeAOUYHkJEBCAu2Obr6UgBmEnOm_QbXAogWBsWu1oMeta } from "/opt/build/repo/nuxt/app/pages/[...slug].vue?macro=true";
import { default as _91slug_93POJTXyA__45FDH2qXHkbn0k9qIprzdy_45hc78gpk8_45_45EDQMeta } from "/opt/build/repo/nuxt/app/pages/article/[slug].vue?macro=true";
import { default as sentry_45example_45pageJunaUynLRMhj_45H3M1gx2SBnyWQT_45gUqto9xU7OS0AvEMeta } from "/opt/build/repo/nuxt/app/pages/sentry-example-page.vue?macro=true";
import { default as component_45stubGdvRzlJT3o09qEcgA1SXwb6AnabbnuZwoj_45uPe2g4CQMeta } from "/opt/build/repo/node_modules/.pnpm/nuxt@3.16.2_@parcel+watcher@2.5.1_@types+node@22.14.1_db0@0.3.1_eslint@9.24.0_jiti@2.4.2__ior_m3iozr3inc3kxemea6li2waq6a/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubGdvRzlJT3o09qEcgA1SXwb6AnabbnuZwoj_45uPe2g4CQ } from "/opt/build/repo/node_modules/.pnpm/nuxt@3.16.2_@parcel+watcher@2.5.1_@types+node@22.14.1_db0@0.3.1_eslint@9.24.0_jiti@2.4.2__ior_m3iozr3inc3kxemea6li2waq6a/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "index___da",
    path: "/",
    component: () => import("/opt/build/repo/nuxt/app/pages/index.vue")
  },
  {
    name: "index___en",
    path: "/en",
    component: () => import("/opt/build/repo/nuxt/app/pages/index.vue")
  },
  {
    name: "slug___da",
    path: "/:slug(.*)*",
    component: () => import("/opt/build/repo/nuxt/app/pages/[...slug].vue")
  },
  {
    name: "slug___en",
    path: "/en/:slug(.*)*",
    component: () => import("/opt/build/repo/nuxt/app/pages/[...slug].vue")
  },
  {
    name: "article-slug___da",
    path: "/article/:slug()",
    component: () => import("/opt/build/repo/nuxt/app/pages/article/[slug].vue")
  },
  {
    name: "article-slug___en",
    path: "/en/article/:slug()",
    component: () => import("/opt/build/repo/nuxt/app/pages/article/[slug].vue")
  },
  {
    name: "sentry-example-page___da",
    path: "/sentry-example-page",
    component: () => import("/opt/build/repo/nuxt/app/pages/sentry-example-page.vue")
  },
  {
    name: "sentry-example-page___en",
    path: "/en/sentry-example-page",
    component: () => import("/opt/build/repo/nuxt/app/pages/sentry-example-page.vue")
  },
  {
    name: component_45stubGdvRzlJT3o09qEcgA1SXwb6AnabbnuZwoj_45uPe2g4CQMeta?.name,
    path: "/sitemap.xml",
    component: component_45stubGdvRzlJT3o09qEcgA1SXwb6AnabbnuZwoj_45uPe2g4CQ
  },
  {
    name: component_45stubGdvRzlJT3o09qEcgA1SXwb6AnabbnuZwoj_45uPe2g4CQMeta?.name,
    path: "/en/sitemap.xml",
    component: component_45stubGdvRzlJT3o09qEcgA1SXwb6AnabbnuZwoj_45uPe2g4CQ
  }
]